module.exports = {
  AtomicBoxPlugin: {
    PluginName: "AI İçerik Elementi",
    accordion_element: "Element",
    accordion_style: "Stil",
    element_type: "Tip",
    theme_id: "Tema",
    padding: "Dolgu",
    background_color: "Arka plan",
    border_width: "Kenarlık kalınlığı",
    border_style: "Kenarlık stili",
    border_color: "Kenarlık rengi",
    border_radius: "Köşe yarıçapı",
    opacity: "Opaklık",
    loading: "Yükleniyor…",
    error: "Render kullanılamıyor",
    element_types: {
      heading: "Başlık",
      eyebrow: "Üst Başlık",
      footer: "Alt Bilgi",
      quote: "Alıntı",
      "bullet-list": "Maddeleme",
      "card-grid": "Kartlar",
      timeline: "Zaman Çizelgesi",
      "stat-group": "İstatistikler",
      hero: "Ana Başlık",
      section: "Bölüm",
      "two-column": "İkili Sütun",
      comparison: "Karşılaştırma",
      divider: "Ayraç",
      badge: "Etiket",
      "cta-button": "Aksiyon Butonu",
      "icon-block": "İkon Bloğu",
    },
  },
};
